const KILOMETRO = 1;
const LOCALIZACAO_FALLBACK = [-15.7963148,-47.8773837];
const RAIO_FALLBACK = 40 * KILOMETRO;

export const localizacao = (state = LOCALIZACAO_FALLBACK, action) => {
  switch(action.type) {
    case 'FETCH_GEOLOCATION_SUCCESS':
    case 'SET_COORDENADAS':
      return action.coordenadas;
    default: return state;
  }
};

export const raio = (state = RAIO_FALLBACK, action) => {
  switch(action.type) {
    case 'SET_RAIO': return action.raio;
    default: return state;
  }
};

export const localizacaoIsLoading = (state = false, action) => {
  switch(action.type) {
    case 'LOADING_GEOLOCATION': return action.loading
    default: return state;
  }
};

export const isModalLocalizacaoOpened = (state = false, action) => {
  switch (action.type) {
    case 'ABRE_MODAL_LOCALIZACAO': return true;
    case 'FECHA_MODAL_LOCALIZACAO': return false;
    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/geolocation.js